import request from '@server';

// 搜索框推荐关键词，PC/H5 共用。
export async function readSearchKeywords() {
    return await request.get('/api/v5/menus', {
        'switch[search_keyword]': 1,
        'searchKeyword[page]': 1,
        'searchKeyword[perPage]': 6,
    }, { skipErrorToast: true });
}

// 获取话题分类列表
export async function readTopicCategoryList(params = {}, ctx = null) {
    return await request.get('/api/v5/topics/categories', params);
}

/**
 * 上传附件接口
 * @param {FormData} formData - 表单数据，包含 type 和 file 字段
 * @param {number} formData.type - 附件类型 1-图片 2-视频
 * @param {File} formData.file - 文件对象
 * @returns {Promise<{code: number, data?: {id: number, url: string}, message?: string}>} 返回结果
 */
export async function uploadAttachment(formData) {
    return await request.post('/api/v3/attachments', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export async function readForum(params = {}, ctx = null) {
    return await request.get('/api/v3/forum', params);
}
export async function readPluginList(params = {}, ctx = null) {
    return await request.get('/plugin/list', params);
}
// 获取用户信息
export async function readUser(params = {}, ctx = null) {
    return await request.get('/api/v3/user', params);
}
// 获取当前登录用户的等级和商城折扣权益。
export async function readUserLevel(params = {}, ctx = null) {
    return await request.get('/api/v3/user.level', params);
}
// 获取当前用户 V 币明细
export async function readUserScoreRecords(params = {}, ctx = null) {
    return await request.get('/api/v3/user.score.recode', params);
}
export async function readPermissions(params = {}, ctx = null) {
    return await request.get('/user/permissions', params);
}
// 获取帖子列表
export async function readThreadList(params = {}, ctx = null) {
    return await request.get('/api/v5/index.thread', params);
}
// 获取话题帖子列表
export async function readTopicThreadList(params, ctx = null) {
    return await request.get(`/api/v5/topics/threads`, params);
}
// 获取话题列表
export async function readTopicList(params, ctx = null) {
    return await request.get(`/api/v5/topics`, params);
}
// 批量获取话题详情（通过ID过滤）
export async function readTopicsByIds(params = {}, ctx = null) {
    return await request.get(`/api/v5/topics`, params);
}
// 获取话题详情
export async function readTopicDetail(id, params = {}, ctx = null) {
    return await request.get(`/api/v5/topics/${id}`, params);
}
// 关注话题
export async function topicsFollow(id, params = {}, ctx = null) {
    return await request.post(`/api/v5/topics/${id}/follow`, params);
}
// 取消关注话题
export async function topicsUnFollow(id, params = {}, ctx = null) {
    return await request.post(`/api/v5/topics/${id}/unfollow`, params);
}
// 获取活动列表
export async function readactivityList(params = {}, ctx = null) {
    return await request.get(`/api/v5/activities`, params);
}
// 获取用户收藏活动列表
export async function readactivityFavoriteList(params = {}, ctx = null) {
    return await request.get(`/api/v5/activities/favorite`, params);
}
// 获取活动详情
export async function readActivityDetail(id, params = {}, ctx = null) {
 // 检查params是否有有效值
    let hasValidParams = false;
    if (params) {
        if (typeof params === 'string' && params.trim() !== '') {
            hasValidParams = true;
        } else if (typeof params === 'object' && params !== null) {
            if (Object.keys(params).length > 0) {
                hasValidParams = true;
            }
        }
    }
    
    let path = `/api/v5/threads/${id}`;
    if (hasValidParams) {
        // 如果是对象，转换为查询字符串
        if (typeof params === 'object' && params !== null) {
            const queryStr = new URLSearchParams(params).toString();
            path += `?${queryStr}`;
        } else {
            // 如果是字符串，直接拼接
            path += `?code=${params}`;
        }
    }
    
    return await request.get(path);
}
// 获取帖子评论列表
export async function readPostList(params = {}, ctx = null) {
    return await request.get(`/api/v5/posts`, params);
}
// 获取单条评论
export async function getSinglePost(id, ctx = null) {
    return await request.get(`/api/v3/posts/${id}`);
}
// 创建帖子
const feedbackPublishErrorMessage = '当前访问人数过多，请稍后访问';

async function submitThread(url, params) {
    const isPCFeedbackPublish = Number(params.type) === 2 && params.source === 'PC' && !params.isDraft;
    if (!isPCFeedbackPublish) return await request.post(url, params);

    try {
        // 由发布页面统一提示，避免网络异常同时弹出底层英文错误。
        const result = await request.post(url, params, { skipErrorToast: true });
        const code = Number(result.code);
        if (result.errorType === 'network' || (code >= 500 && code < 600) || code === -5002) {
            return { ...result, msg: feedbackPublishErrorMessage, message: feedbackPublishErrorMessage };
        }
        return result;
    } catch (error) {
        return { code: -1, msg: feedbackPublishErrorMessage, message: feedbackPublishErrorMessage };
    }
}

export async function createPost(params = {}, ctx = null) {
    return await submitThread('/api/v3/thread.create', params);
}
// 创建帖子
export async function updatePost(params = {}, ctx = null) {
    return await submitThread('/api/v3/thread.update', params);
}
// 帖子互转：普通帖转反馈传问题类型，反馈转动态传话题数组。
export async function moveThread(threadId, params) {
    const formData = new FormData();
    formData.append('targetType', String(params.targetType));
    if (params.targetType === 2) {
        formData.append('problemId', String(params.problemId));
    } else {
        // 与 Apifox curl 一致：每个话题 ID 使用一个同名的 topicIds[] 表单项。
        const topicIds = (params.topicIds || []).map(Number);
        if (topicIds.some(id => !Number.isSafeInteger(id) || id <= 0)) {
            throw new Error('话题 ID 无效');
        }
        topicIds.forEach(id => formData.append('topicIds[]', String(id)));
    }
    return await request.post('/api/v5/threads/' + encodeURIComponent(String(threadId)) + '/move', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}
// 获取用户勋章
export async function readUserMedal(params = {}, ctx = null) {
    return await request.get(`/api/v3/user.medal`, params);
}
// 获取用户帖子列表
export async function readUsersThreads(code, params = {}, ctx = null) {
    return await request.get(`/api/v4/users/${code}/threads`, params);
}
// 获取用户评论列表
export async function readUsersPosts(code, params = {}, ctx = null) {
    return await request.get(`/api/v4/users/${code}/posts`, params);
}
// 获取用户点赞列表
export async function readUsersLikes(code, params = {}, ctx = null) {
    return await request.get(`/api/v5/users/${code}/likes`, params);
}
// 获取用户收藏列表
export async function readUsersFavorites(code, params = {}, ctx = null) {
    return await request.get(`/api/v5/users/${code}/favorites`, params);
}
// 关注用户
export async function createFollow(params = {}, ctx = null) {
    return await request.post('/api/v3/follow.create', params);
}
// 取消关注或移除粉丝
export async function followDelete(params = {}, ctx = null) {
    return await request.post('/api/v3/follow.delete', params);
}
// 用户登出
export async function userLogout(params = {}, ctx = null) {
    return await request.get('/api/v3/users/vivo/logout', params);
}
// 获取关注的话题
export async function readTopicsFollows(params = {}, ctx = null) {
    return await request.get(`/api/v5/topics/follows`, params);
}
// 获取帖子详情
export async function readThreadDetail(id, params, ctx = null) {
    // 检查params是否有有效值
    let hasValidParams = false;
    if (params) {
        if (typeof params === 'string' && params.trim() !== '') {
            hasValidParams = true;
        } else if (typeof params === 'object' && params !== null) {
            if (Object.keys(params).length > 0) {
                hasValidParams = true;
            }
        }
    }
    
    let path = `/api/v5/threads/${id}`;
    if (hasValidParams) {
        // 如果是对象，转换为查询字符串
        if (typeof params === 'object' && params !== null) {
            const queryStr = new URLSearchParams(params).toString();
            path += `?${queryStr}`;
        } else {
            // 如果是字符串，直接拼接
            path += `?code=${params}`;
        }
    }
    
    return await request.get(path);
}
// 点赞帖子、评论
export async function createUserslikes(params = {}, ctx = null) {
    return await request.post('/api/v5/users/likes', params);
}
// 帖子置顶、取消置顶，沉帖，精华，屏蔽，推荐，删除
export async function threadOpera(params = {}, ctx = null) {
    return await request.post('/api/v3/threads/operate', params);
}
// 帖子收藏
export async function threadFavorite(params = {}, ctx = null) {
    return await request.post('/api/v5/users/favorites', params);
}
// 帖子分享
export async function threadShare(params = {}, ctx = null) {
    return await request.post('/api/v3/thread.share', params);
}
// 举报
export async function reports(params = {}, ctx = null) {
    return await request.post('/api/v3/reports', params);
}
// 发评论、打赏（打赏也是发评论的一种）
export async function postsCreate(params = {}, ctx = null) {
    return await request.post('/api/v3/posts.create', params);
}
// 帖子详情内的投票
export async function votesOptions(vote, params, ctx = null) {
    return await request.post(`/api/v5/votes/${vote}/voting`, params);
}
// 获取banner列表
export async function readBannerList(params = {}, ctx = null) {
    return await request.get(`/api/v3/banner.list`, params);
}
// 获取表情列表
export async function readEmoji(params = {}, ctx = null) {
    return await request.get('/api/v3/emoji', params);
}
// 关注/粉丝列表
export async function readFollowList(params = {}, ctx = null) {
    return await request.get('/api/v3/follow.list', params);
}
// 推荐用户列表
export async function readRecommendUserList(params = {}, ctx = null) {
    return await request.get('/api/v3/recommend.user.list', params);
}
// 获取帖子详情（用于编辑/回显）
export async function readPostDetail(id, params = {}, ctx = null) {
    return await request.get(`/api/v5/threads/${id}`, params);
}
// 获取评论详情（用于回显到评论列表顶部）
export async function readCommentDetail(params = {}, ctx = null) {
    return await request.get(`/api/v3/posts.detail`, params);
}

// 帖子详情内的投票
export async function postsUpdate(params, ctx = null) {
    return await request.post(`/api/v3/posts.update`, params);
}
// 查询草稿
export async function fetchDraft(params = {}, ctx = null) {
    return await request.post(`/api/v4/draft/fetch`, params);
}
// 搜索用户列表
export async function searchUsersList(params = {}, ctx = null) {
    return await request.get('/api/v3/users.list', params);
}
// 获取 OSS 签名信息（用于文件直传上传）
export async function readOssSignature(params = {}, ctx = null) {
    return await request.get('/api/v5/upload-videos/web', params);
}

// 获取链接白名单（用于过滤和兼容 deeplink）
export async function readLinkWhitelist(params = {}, ctx = null) {
    return await request.get('/api/v4/app/link-whitelist', params);
}
// 获取评论详情(楼中楼评论)
export async function readPostComments(postId, params = {}, ctx = null) {
    return await request.get(`/api/v4/posts/${postId}/comments`, params);
}
// 获取推荐帖子列表
export async function readIndexRecommendThread(params = {}, ctx = null) {
    return await request.get(`/api/v5/index.recommend.thread`, params);
}
// 获取帖子列表
export async function readThreads(params = {}, ctx = null) {
    return await request.get(`/api/v4/threads`, params);
}

// 房产证活动点赞
export async function houseCertlike(params = {}, ctx = null) {
    return await request.post(`/api/v5/house-cert/like`, params);
}
// 生成房产证
export async function houseCertGenerate(params = {}, ctx = null) {
    return await request.post(`/api/v5/house-cert/generate`, params);
}
// 房产证领取
export async function houseCertClaim(params = {}, ctx = null) {
    return await request.post(`/api/v5/house-cert/claim`, params);
}
// 房产证信息
export async function readHouseCert(params = {}, ctx = null) {
    return await request.get(`/api/v5/house-cert`, params);
}
// 房产证活动统计
export async function readHouseCertTotal(params = {}, ctx = null) {
    return await request.get(`/api/v5/house-cert/total`, params);
}

// 提交表单
export async function submitForm(formId, params = {}, ctx = null) {
    return await request.post(`/api/v5/forms/${formId}/submit`, params);
}

// 获取摄影大赛列表
export async function readPhotographyContestsList(params = {}, ctx = null) {
    return await request.get(`/api/v5/photography/contests`, params);
}
// 获取摄影大赛详情
export async function readPhotographyContestsDetail(id, ctx = null) {
    return await request.get(`/api/v5/photography/contests/${id}`);
}
// 获取摄影大赛投稿列表
export async function readPhotographyContestsWorks(id, params, ctx = null) {
    return await request.get(`/api/v5/photography/contests/${id}/works`, params);
}
// 获取摄影大赛投稿详情
export async function readPhotographyWorks(id, ctx = null) {
    return await request.get(`/api/v5/photography/works/${id}`);
}
// 获取摄影影展详情
export async function readPhotographyExhibitions(id, params = {}, ctx = null) {
    return await request.get(`/api/v5/photography/exhibitions/${id}`, params);
}
// 获取摄影大赛我的作品列表
export async function readPhotographyContestMyWorks(id, params, ctx = null) {
    return await request.get(`/api/v5/photography/contests/${id}/my-works`, params);
}
// 获取摄影大赛我的投票列表
export async function readPhotographyContestMyVotes(id, params, ctx = null) {
    return await request.get(`/api/v5/photography/contests/${id}/my-votes`, params);
}
// 删除作品
export async function deletePhotographyWork(id, ctx = null) {
    return await request.delete(`/api/v5/photography/works/${id}`);
}
// 获取摄影大赛我的投票列表
export async function readPhotographyWorksDetail(id, ctx = null) {
    return await request.get(`/api/v5/photography/works/${id}`);
}
// 大赛作品投票
export async function submitPhotographyWorksVote(id, ctx = null) {
    return await request.post(`/api/v5/photography/works/${id}/vote`);
}
// 获取试用产品列表
export async function readProductList(params, ctx = null) {
    return await request.get(`/api/v3/trial.product.list`, params);
}
// 获取我的使用产品列表
export async function readProductMyList(params, ctx = null) {
    return await request.get(`/api/v3/trial.product.my`, params);
}
// 获取试用产品详情
export async function readProductDetail(params, ctx = null) {
    return await request.get(`/api/v3/trial.product.detail`, params);
}
// 获取商品详情
export async function readGoodsDetail(params, ctx = null) {
    return await request.get(`/api/v3/goods.detail`, params);
}
// 获取商品列表
export async function readGoodsList(params, ctx = null) {
    return await request.get(`/api/v3/goods.list`, params);
}
// 获取我的试用码
export async function readProductCode(params, ctx = null) {
    return await request.get(`/api/v3/trial.product.code`, params);
}
// 兑换试用码
export async function submitProductCodeExchange(params, ctx = null) {
    return await request.post(`/api/v3/trial-code/exchange`, params);
}
// 获取新品众测邀请码
export async function readInviteLinkCreate(params, ctx = null) {
    return await request.get(`/api/v3/invite.link.create`, params);
}
// 产品使用报名
export async function submitProductEnroll(params, ctx = null) {
    return await request.post(`/api/v3/trial.product.enroll`, params);
}
// 获取规则
export async function readSettings(params, ctx = null) {
    return await request.get(`/api/v3/settings`, params);
}
// 抽奖
export async function submitLotteryDraw(params, ctx = null) {
    // skipErrorToast: 抽奖失败由页面统一提示中文文案，跳过底层全局英文错误提示
    const ret = await request.post(`/api/v5/lottery-activities/draw`, params, { skipErrorToast: true });
    // 请求层会将网络异常标记在返回对象上；抽奖场景需要将其与接口 code 非 0 的业务失败区分开
    if (ret?.errorType === 'network') {
        const err = new Error(ret.msg || '网络发生错误');
        err.errorType = 'network';
        throw err;
    }
    return ret;
}
// 获取抽奖信息
export async function getLotteryActivities(id, ctx = null) {
    return await request.get(`/api/v5/lottery-activities/${id}`);
}
// 获取抽奖活动-抽奖券记录
export async function getLotteryActivitiesTickets(id, params, ctx = null) {
    return await request.get(`/api/v5/lottery-activities/${id}/tickets`, params);
}
// 获取本次中奖记录
export async function getLotteryActivitiesRecords(id, params, ctx = null) {
    return await request.get(`/api/v5/lottery-activities/${id}/records`, params);
}
// 获取抽奖活动-邀请记录
export async function getLotteryActivitiesInvitations(id, params, ctx = null) {
    return await request.get(`/api/v5/lottery-activities/${id}/invitations`, params);
}
// 获取我的抽奖
export async function getLotteryActivitiesDraws(params, ctx = null) {
    return await request.get(`/api/v5/lottery-activities/draws`, params);
}
// 我的奖品列表
export async function getMyPrizeWinningList(params, ctx = null) {
    return await request.get(`/api/v5/user.winning.list`, params);
}
// 兑换记录列表
export async function getPrizeExchangeList(params, ctx = null) {
    return await request.get(`/api/v3/exchange.list`, params);
}
// 商品兑换
export async function submitGoodsExchange(params, ctx = null) {
    // 兑换接口接收商品 code、地址 ID；权益类商品额外传递 IMEI。
    const exchangeParams = {
        code: params?.code,
        addressId: params?.addressId ?? null,
    };
    if (params?.imei !== undefined && params?.imei !== null) {
        exchangeParams.imei = params.imei;
    }
    return await request.post(`/api/v3/exchange`, exchangeParams);
}
// 抽奖商品抽奖
export async function submitLotteryGoodsDraw(params, ctx = null) {
    // 抽奖接口只接收商品 code。
    return await request.post(`/api/v5/lottery.goods.draw`, {
        code: params?.code,
    });
}
// 用户收货地址列表
export async function getUserAddressList(params, ctx = null) {
    return await request.get(`/api/v3/user.address.list`, params);
}
// 删除用户收货地址
export async function deleteUserAddress(params, ctx = null) {
    return await request.post(`/api/v3/user.address.delete`, params);
}
// 新增用户收货地址
export async function insertUserAddress(params, ctx = null) {
    return await request.post(`/api/v3/user.address.insert`, params);
}
// 获取用户收货地址详情
export async function getUserAddressDetail(params, ctx = null) {
    return await request.get(`/api/v3/user.address.detail`, params);
}
// 编辑用户收货地址
export async function updateUserAddress(params, ctx = null) {
    return await request.post(`/api/v3/user.address.update`, params);
}
// 修改订单收货地址，id 为中奖记录 id，addressId 为收货地址 id。
export async function updateOrderAddress(params, ctx = null) {
    return await request.post(`/api/v3/order.address.update`, params);
}
// 设置用户默认收货地址，接口参数使用小写 id。
export async function setDefaultUserAddress(params, ctx = null) {
    return await request.post(`/api/v3/user.address.default`, params);
}
// 省市区三级地址列表，子级通过父级 code 获取
export async function getAddressRegionList(params = {}, ctx = null) {
    return await request.get(`/api/v3/address.list`, params);
}
// 抽奖分享
export async function submitLotteryActivitiesOpenShare(params, ctx = null) {
    return await request.post(`/api/v5/lottery-activities/open-share`, params);
}
// 获取抽奖活动-额外惊喜
export async function getLotteryActivitiesSurprises(id, params, ctx = null) {
    return await request.get(`/api/v5/lottery-activities/${id}/surprises`, params);
}
// 获取抽奖活动-弹幕
export async function getLotteryActivitiesBarrage(id, ctx = null) {
    return await request.get(`/api/v5/lottery-activities/${id}/barrage`);
}
// 完成打开链接任务
export async function submitLotteryOpenUrl(params, ctx = null) {
    return await request.post(`/api/v5/lottery-activities/open-url`, params);
}
// 获取消息通知
export async function readNotifications(params, ctx = null) {
    return await request.get(`/api/v5/notifications`, params);
}
// 获取未读消息数
export async function unreadNotifications(params, ctx = null) {
    return await request.get(`/api/v3/unreadnotification`, params);
}
// 获取私信消息列表
export async function getChatMessageList(params, ctx = null) {
    return await request.get(`/api/v4/chat/message/list`, params);
}
// 获取私信列表
export async function getChatList(params, ctx = null) {
    return await request.get(`/api/v4/chat/list`, params);
}
// 消息一键已读
export async function submitNotificationsRead(params, ctx = null) {
    return await request.post(`/api/v3/notifications/read`, params);
}
// 发私信
export async function submitChatMessageSend(params, ctx = null) {
    return await request.post(`/api/v4/chat/message/send`, params);
}
// 获取与某一用户的对话框
export async function getChatRoomFind(params, ctx = null) {
    return await request.get(`/api/v4/chat/room/find`, params);
}
// 我也有相同问题
export async function submitFeedbackSame(id, params, ctx = null) {
    return await request.post(`/api/v3/feedback/${id}/same`, params);
}
// 获取问题反馈列表（包含我的）
export async function readFeedbacks(params, ctx = null) {
    return await request.get(`/api/v5/feedbacks`, params);
}
// 获取问题反馈-问题类型列表
export async function readFeedbackProblems(params, ctx = null) {
    return await request.get(`/api/v3/feedbacks/problems`, params);
}
// 获取已解决问题数量
export async function readFeedbackSolvedCount(params, ctx = null) {
    return await request.get(`/api/v5/feedbacks/solved-count`, params);
}
// 获取手机型号分类列表
export async function readProductCategories(params, ctx = null) {
    return await request.get(`/api/v5/products/categories`, params);
}
// 获取产品列表
export async function readProducts(params, ctx = null) {
    return await request.get(`/api/v5/products`, params);
}
// 用户确认有无帮助
export async function submitFeedbackConfirm(id, params, ctx = null) {
    return await request.post(`/api/v3/feedback/${id}/confirm`, params);
}
// 获取嘉年华活动详情，params.code 为活动标识
export async function readCarnivalActivities(params, ctx = null) {
    return await request.get(`/api/v5/carnival-activities`, params);
}
